var _title, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconUser = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "icon icon--user",
  ref: svgRef
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "User icon")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 7,
  r: 4
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconUser.013aea2c.svg";
export { ForwardRef as ReactComponent };